import { UserAuth } from '../context/AuthContext';

export function useUI(uiKey) {
  const { user } = UserAuth();
  if (!user) return false;
  if (user.isAdmin) return true;
  return user.allowedUI?.includes(uiKey) || false;
}

export function useAnyUI(...uiKeys) {
  const { user } = UserAuth();
  if (!user) return false;
  if (user.isAdmin) return true;
  return uiKeys.some(key => user.allowedUI?.includes(key));
}

export function useAllUI(...uiKeys) {
  const { user } = UserAuth();
  if (!user) return false;
  if (user.isAdmin) return true;
  return uiKeys.every(key => user.allowedUI?.includes(key));
}
